import { writable } from "svelte/store";

const getRoute = () =>
  decodeURIComponent(window.location.pathname).replace(/^\/+|\/+$/g, "");

// Redirect old hash URLs (jasminevenes.com/#/work) to clean paths.
if (window.location.hash.indexOf("#/") === 0) {
  window.history.replaceState(null, "", window.location.hash.slice(1) || "/");
}

export const route = writable(getRoute());

const sync = () => {
  route.set(getRoute());
  window.scrollTo(0, 0);
};

export const navigate = (path) => {
  window.history.pushState(null, "", path);
  sync();
};

// Click handler for internal <a> links: keep them real links (cmd-click,
// middle-click, copy address all work) but route in-app on plain clicks.
export const link = (e) => {
  if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) {
    return;
  }
  e.preventDefault();
  navigate(e.currentTarget.getAttribute("href"));
};

window.addEventListener("popstate", sync);
